import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.meine-mandanten';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMeineMandantenEffects {

    MeineMandanten$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MEINE_MANDANTEN),
        mergeMap((x: ac.GetMeineMandantenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMeineMandanten(x.logos, x.pWidth, x.pHheight).pipe(
                map((result: any) => {
                    return new ac.GetMeineMandantenErfolgreichAction(result, x.logos, x.pWidth, x.pHheight, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMeineMandantenFehlerAction(error, x.logos, x.pWidth, x.pHheight, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenService);
        }
        return this.service;
    }
}
